import { render } from "./GeneralBodyCouncil.vue?vue&type=template&id=40892d17&scoped=true"
import script from "./GeneralBodyCouncil.vue?vue&type=script&lang=js"
export * from "./GeneralBodyCouncil.vue?vue&type=script&lang=js"

import "./GeneralBodyCouncil.vue?vue&type=style&index=0&id=40892d17&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40892d17"]])

export default __exports__